import StoredTranslationData from '../store/schema/StoredTranslationData';
import { ClientType } from './clientType';
import { CustomData } from 'owa-analytics-actions';
import { logUsage } from 'owa-analytics';

export default function isCachedContentValid(translationData: StoredTranslationData): boolean {
    const clientType = translationData?.clientType;

    if (clientType === ClientType.OWA) {
        return true;
    }

    const customData: CustomData = clientType ? { clientType: clientType } : { clientType: 0 };

    logUsage('InlineTranslationInvalidCache', customData);

    return false;
}
